export default __webpack_public_path__ + "static/media/cactus.0b2b567b.png";